import styled from "styled-components"
import Flex from "./flex"

export default styled(Flex)`
  padding-left: ${({ spacing }) => 0.5 * spacing}rem;
  padding-right: ${({ spacing }) => 0.5 * spacing}rem;
`
